import React from 'react';

interface TabsProps {
  activeTab: string;
  onTabClick: (tab: string) => void;
}

const Tabs: React.FC<TabsProps> = ({ activeTab, onTabClick }) => {
  return (
    <div className="tabs">
      <button onClick={() => onTabClick('国际')} className={activeTab === '国际' ? 'active' : ''}>
        国际
      </button>
      <button onClick={() => onTabClick('国内')} className={activeTab === '国内' ? 'active' : ''}>
        国内
      </button>
      <button onClick={() => onTabClick('自家网络设置')} className={activeTab === '自家网络设置' ? 'active' : ''}>
        自家网络设置
      </button>
    </div>
  );
};

export default Tabs;
